import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/BasicUserName';
import { getMoreByLinkType } from '../../helpers';
import s from './MoreByAuthor.scss';
var MoreByAuthor = function (_a) {
    var contentType = _a.contentType, author = _a.author, className = _a.className;
    return (React.createElement(UserLink, { className: classnames(s['root'], className), user: author, linkTo: getMoreByLinkType(contentType) },
        React.createElement(Trans, { i18nKey: "sidebar.blockTitle.".concat(contentType) },
            "More things by ",
            React.createElement(BasicUserName, { user: author }))));
};
MoreByAuthor.displayName = 'MoreByAuthor';
export default MoreByAuthor;
//# sourceMappingURL=MoreByAuthor.js.map